<template>
  <el-row
    class="pageSize"
    style="margin: 0 auto; padding-top: 15px;"
  >

    <Head homeTitle="销售适当性"></Head>
    <el-row>
      <el-col
        :span="1"
        class="line_border_bottom el-tabs__item"
      >
      </el-col>
      <el-col :span="23">
        <el-tabs
          v-model="activeName"
          type="card"
          @tab-click="latestReload"
        >
          <el-tab-pane
            label="我的列表"
            name="first"
          >
            <LatestEvaluation
              ref="latest"
              @redirectRiskLevelDataBase="
                                redirectRiskLevelDataBase
                            "
            ></LatestEvaluation>
          </el-tab-pane>
          <el-tab-pane
            label="基金详情"
            name="second"
          >
            <RiskLevelDataBase ref="riskDB"></RiskLevelDataBase>
          </el-tab-pane>
          <el-tab-pane
            label="公司评价"
            name="third"
          >
            <CompanyEvaluation ref="companyEvaluation"></CompanyEvaluation>
          </el-tab-pane>
          <el-tab-pane
            label="方法论"
            name="fourth"
          >
            <Methodology ref="methodology"></Methodology>
          </el-tab-pane>
          <el-tab-pane
            label="基金筛选"
            name="fifth"
          >
            <FundSelector
              ref="fundSelector"
              @redirectRiskLevelDataBase="
                                redirectRiskLevelDataBase
                            "
            ></FundSelector>
          </el-tab-pane>
          <!--el-tab-pane
            label="组合风险"
            name="sixth"
          >即将上线 ，敬请期待！</el-tab-pane-->
          <el-tab-pane
            label="风险画像"
            name="seventh"
          >
            <RiskPortrait ref="riskPortrait"></RiskPortrait>
          </el-tab-pane>
          <el-tab-pane
          :disabled="!showRiskDetail"
            label="子项风险"
            name="eighth"
          >
            <RiskDetail 
              ref="riskDetail"
               @redirectRiskLevelDataBase="
                                redirectRiskLevelDataBase
                            "></RiskDetail>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row><br />
  </el-row>
</template>
<script>

import LatestEvaluation from "../../components/main/LatestEvaluation";
import RiskLevelDataBase from "../../components/main/RiskLevelDataBase";
import Methodology from "../../components/main/Methodology";
import CompanyEvaluation from "../../components/main/CompanyEvaluation";
import FundSelector from "../../components/main/FundSelector";
import RiskPortrait from "../../components/main/RiskPortrait";
import RiskDetail from "../../components/main/RiskDetail";

const componentsCommon=require("cb-components-common").default;
const routerPush=componentsCommon.common.routerPush;
const getNameAndValue=componentsCommon.localStorage.getNameAndValue;
const getSuitabilityMemberSeniorTrial = componentsCommon.common.getSuitabilityMemberSeniorTrial;
const getSuitabilityMemberSenior = componentsCommon.common.getSuitabilityMemberSenior;
let Head = componentsCommon.Head;

export default {
    data() {
        return {
            activeName: "first",
            showRiskDetail:false
        };
    },
    watch: {
        activeName: function(val,oldVal) {          
            let self = this;
            switch (val) {
                case "first":
                    self.$refs.latest.loadingData();                          
                    break;
                case "second":
                    self.$refs.riskDB.getFundInformation();
                      break;
                case "third":
                    self.$refs.companyEvaluation.loadingData();
                    break;
                case "fourth":
                    self.$refs.methodology.loadingData(1);
                    break;
                case "fifth":
                    self.$refs.fundSelector.loadingData();
                    break;
                case "seventh":
                    self.$refs.riskPortrait.loadingData();
                    break;
                case "eighth":
                    self.$refs.riskDetail.loadingData();
                    break;
            }

            // console.log('new:'+val,'old:'+oldVal);
            if (!!(window.history && history.pushState) && val != oldVal){
              window.history.pushState({activeName:self.activeName},null);              
            }
        }
    },
    components: {
        LatestEvaluation,
        RiskLevelDataBase,
        Methodology,
        CompanyEvaluation,
        FundSelector,
        Head,
        RiskPortrait,
        RiskDetail
    },
    methods: {
        redirectRiskLevelDataBase(symbol) {
            let self = this;
            self.activeName = "second";
            self.$refs.riskDB.getFundInformation(symbol);
        },
        latestReload(para) {
            let self = this;
            if (para.name == "first") {
                self.$refs.latest.loadingData();
            }
        }
    },
    mounted() {      
        const self = this;
        if (!!(window.history && history.pushState)){          
          if(self.activeName=='first'||self.activeName==''||self.activeName==undefined){
              window.history.pushState({activeName:'first'},null);
          }        

          window.onpopstate = function(event){
            if(event.state.activeName!='' && event.state.activeName!=undefined)
            {
              if(event.state.activeName==self.activeName)
              {
                // console.log('the same!');
                window.history.back();
              }
              else{
                self.activeName = event.state.activeName;
              } 
            } 
            else
            {                        
              routerPush("/home",self);
            }
          }      

          //下面注释和上面一样，都可用
          // window.addEventListener('popstate', function(event) {
          //   // console.log(event.state.activeName);
          //   // console.log(`state: ${JSON.stringify(event.state)}`);         
          //   // console.log('popstate:'+self.activeName);
          //   if(event.state && event.state.activeName!='' && event.state.activeName!=undefined)
          //   {
          //     if(event.state.activeName==self.activeName)
          //     {
          //       // console.log('the same!');
          //       window.history.back();
          //     }
          //     else{
          //       self.activeName = event.state.activeName;
          //     }              
          //   } 
          //   else
          //   {             
          //     routerPush("/home",self);
          //   }
          // });  

          let userInfo = JSON.parse(getNameAndValue("info"));
          if(userInfo != null && userInfo.suitability == 1
            && ((userInfo.suitabilityMemberSeniorTrial != null && userInfo.suitabilityMemberSeniorTrial) 
              || (userInfo.suitabilityMemberSenior != null && userInfo.suitabilityMemberSenior)))
          {
            this.showRiskDetail=true;
          }
          else{
            this.showRiskDetail=false;
          }
        }
    }
};
</script>